import React from 'react';
import Layout from '@/components/layout/Layout';
import { useLanguage } from '@/context/language-context';

const Terms = () => {
  const { t } = useLanguage();
  const currentDate = new Date();
  const formattedDate = `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;
  
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-2">{t('terms.title')}</h1>
          <p className="text-lg text-muted-foreground mb-6">{t('terms.subtitle')}</p>
          <p className="text-sm text-muted-foreground mb-8">{t('terms.last_updated')} {formattedDate}</p>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-4">{t('terms.introduction.title')}</h2>
              <p className="text-muted-foreground">{t('terms.introduction.content')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground">
                By accessing or using Pink Paradise, you agree to be bound by these Terms and Conditions. 
                If you disagree with any part of the terms, you may not access the service.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">2. Changes to Terms</h2>
              <p className="text-muted-foreground">
                We reserve the right to modify these terms at any time. We will notify users of any changes 
                by updating the date at the top of this page. Continued use of the platform after changes 
                indicates acceptance of the new terms.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">3. User Accounts</h2>
              <p className="text-muted-foreground">
                Users are responsible for maintaining the confidentiality of their account information and 
                for all activities that occur under their account. Users must notify us immediately upon 
                becoming aware of any breach of security or unauthorized use of their account.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-4">4. User Content</h2>
              <p className="text-muted-foreground">
                Users are solely responsible for the content they post on Pink Paradise. By submitting 
                content, users grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, 
                modify, and display the content in connection with our services.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
